import * as React from 'react';

import styled from 'styled-components';

export interface SVGBaseProps {
    children: React.ReactNode;
    onClick?: (e: any) => void;
    fill?: string;
    title?: string;
    width?: string;
    height?: string;
    viewBox?: string;
}

const StyleSvg = styled.svg`
    display: block;
`;

const SVGBase: React.FunctionComponent<React.PropsWithChildren<SVGBaseProps>> = ({
    children,
    fill,
    title,
    width,
    height,
    viewBox,
    ...rest
}) => (
    <StyleSvg viewBox={viewBox} fill={fill} width={width} height={height} {...rest}>
        {title && <title>{title}</title>}
        {children}
    </StyleSvg>
);

export default SVGBase;
